module.exports = __webpack_public_path__ + "img/17.20d7085a.jpg";